import React from 'react';

// Importation des différents composants
import GameOver from '../components/Gameplay-Commun/GameOver';

const GameOverPage = () => {
    return (
        <div>
            <GameOver />
        </div>
    );
};

export default GameOverPage;